<style lang="scss" scoped>
@import "$vars";
.body {
  .content {
    margin-top: 90px;
    > div {
      background: #ecf0f1;
    }
  }
}
main.content {
  min-height: 100vh;
}
.maincontent {

}
.badge[data-badge]::after {
  position: absolute;
  top: 0;
  right: -5px;
}

footer {
  text-align: right;
  margin-right: 2em;
  padding: 1em 0 4em;
  a {
    color: inherit;
    text-decoration: underline;
  }
}

</style>

<template>
  <div class="body" v-if="loaded" @click="toggleProfile = !toggleProfile">
    <access-log
      v-if="showAccessLog"
      :rows="accessLog"
      @close="showAccessLog = false"
    />

    <action-modal
      v-if="actionModal.show"
      :active="actionModal.show"
      :css="actionModal.css"
      :body="actionModal.body"
      :size="actionModal.size"
      :btn="actionModal.btn"
      :action="actionModal.action"
      @close="actionModal.show = false"
    />

    <tutorial
      v-if="!!showTutorial"
      :which.sync="whichTutorial"
      @close="showTutorial = false"
    />

    <template v-if="!fn_IS_MOBILE()">
      <dr-sidebar
        :doctor.sync="doctor"
        :profile="getProfile"
        :access-roles="accessRoles"
        :key="getAuth"
        @show-action-modal="actionModal.show = true"
      />

      <dr-menu-toggle />

      <dr-header
        :doctor.sync="doctor"
        :doctor-id.sync="doctorId"
        :doctor-list.sync="doctorList"
        :profile.sync="getProfile"
        :profile-routes.sync="profileRoutes"
        :outer-toggle-profile="toggleProfile"
        @toggle-tutorial="
          showTutorial = $event;
          whichTutorial = parseInt($event);
        "
      />
    </template>

    <template v-else>
      <mobileNav
        :doctor.sync="doctor"
        :profile="getProfile"
        :access-roles="accessRoles"
        :profile-routes="profileRoutes"
        @toggle-tutorial="
          showTutorial = $event;
          whichTutorial = parseInt($event);
        "
        @show-action-modal="actionModal.show = true"
       />
    </template>

    <main class="maincontent">
      <certifier-alert v-if="!fn_IS_SECRETARY()" />

      <transition :name="'fade'" mode="out-in">
        <router-view
          :doctor.sync="doctor"
          :key="reloadView"
          :timer.sync="timer"
          @reload-tour="tourDisabled = true; fetchDoctor()"
        />
      </transition>
    </main>

    <footer class="activity" v-if="loaded">
      <small v-if="lastAccess">
        Última atividade da conta: {{ $moment(lastAccess).format('DD/MM/YYYY') }},
        às {{ $moment(lastAccess).format('HH:mm') }}
      </small>

      <small v-else>Primeiro acesso</small>

      <br />

      <small v-if="lastAccess">
        <a @click="showAccessLog = true">Detalhes</a>
      </small>
    </footer>

    <!--
    DESABILITANDO TOUR APÓS MUDANÇAS NAS SEÇÕES
    <drTour
      :ref="reloadTour"
      @reloadView="reloadView = $event"
      :tourData.sync="tourData"
      @tourDisabled="tourDisabled = true"
      v-if="!tourDisabled && !isTablet"
      class="tour">
    </drTour> -->

    <dr-timer-window
      v-if="!fn_IS_SECRETARY()"
      @loaded="timerLoaded = true"
    />

    <mercure-listener />

    <telemedicine-appointment />

    <dr-agenda-online-controls
      v-if="appIntegration && appIntegration['app_integration_stages']
        .some(stage => stage.slug === 'dados-bancarios')
      "
      :active.sync="agendaOnlineIsActive"
      :doctor.sync="doctor"
    />
  </div>
</template>

<script>
import header from '@/components/layout/header'
import accessLog from '@/components/modals/accessLog'
import actionModal from '@/components/modals/action'
import sidebar from '@/components/layout/sidebar'
import drTimerWindow from '@/components/timerWindow'
import certifierAlert from '@/components/certifierAlert'
// aparentemente este componente não está sendo utilizado
// import notifications from '@/components/notifications'
// DESABILITANDO TOUR APÓS MUDANÇAS NAS SEÇÕES
// import drTour from '@/components/tour'
import tutorial from '@/components/tutorial'
import mercureListener from '@/components/mercureListener'
import telemedicineAppointment from '@/components/layout/appointments/telemedicine'
import DrAgendaOnlineControls from '@/components/modals/agendaOnlineControls'
import DrMenuToggle from '@/components/layout/menuToggle'
import mobileNav from '@/components/layout/mobile/mobileNav'

import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'

export default {
  name: 'DrConecta',

  components: {
    'dr-sidebar': sidebar,
    'dr-header': header,
    drTimerWindow,
    certifierAlert,
    // aparentemente este componente não está sendo utilizado
    // notifications,
    // DESABILITANDO TOUR APÓS MUDANÇAS NAS SEÇÕES
    // drTour,
    tutorial,
    accessLog,
    actionModal,
    mercureListener,
    telemedicineAppointment,
    DrAgendaOnlineControls,
    DrMenuToggle,
    mobileNav
  },
  data () {
    return {
      loaded: false,
      timerLoaded: false,
      tourDisabled: true,
      reloadView: 0,
      reloadTour: 0,
      doctorId: null,
      doctor: {},
      doctorList: [],
      accessRoles: [],
      tourData: null,
      tourSlug: 'veja-como-funciona-o-dr-conecta',
      timer: null,
      profileRoutes: [],
      sidebarRoutes: [],
      toggleProfile: null,
      accessLog: null,
      lastAccess: null,
      showAccessLog: false,
      showTutorial: null,
      whichTutorial: null,
      windowWidth: null,
      actionModal: {
        show: false,
        size: 'md3',
        css: `
          color: white !important;
          background: url(/static/img/modal_cadastro.png);
          background-size: cover;
          background-position: right center
          `,
        btn: {
          class: 'btn-navy ',
          text: 'Cadastrar consultório'
        },
        body: null,
        action: function () {
          this.$router.push('/doctor/user/offices')
          this.close()
        }
      },
      agendaOnlineIsActive: false
    }
  },
  computed: {
    ...mapGetters({
      appIntegration: 'getAppIntegration'
    }),

    getAuth () {
      return this.$store.getters.$_checkAuth
    },
    getProfile () {
      return this.$store.getters.getProfile
    },
    getNewTab () {
      return this.$store.getters.getNewTab
    },
    isMobile () {
      return this.fn_IS_MOBILE()
    }
  },
  watch: {
    getAuth (next) {
      if (!next) {
        this.$router.replace({ name: 'Logout' })
      }
    },
    isMobile (next) {
      if (next) {
        document.querySelector('.maincontent').style.marginLeft = '0'
      }
    },
    '$route.name': function (next, prev) {
      if (this.fn_IS_SECRETARY()) {
        if (!next) {
          this.loaded = false
          this.fetchDoctor()
        }
      }
      if (this.doctor.doctor_offices.length > 0) {
        return
      }
      this.tourDisabled = true

      // Adicione aqui o nome das rotas que deverão ser bloqueadas
      // sem que o médico tenha cadastrado um consultório
      let routes = [
        'DoctorAgenda',
        'DoctorPatients',
        'DoctorFinances',
        'DoctorPrices',
        'DoctorReports',
        'DoctorUsersOfficeList',
        'DoctorServices'
      ]
      //
      for (let route of routes) {
        if (next.indexOf(route.name) > -1) {
          this.actionModal.body = `
          <div class="col-6"><h2 style="color: white">Cadastre seu consultório!</h2>
          <p>Para usufruir de todas as funcionalidades que o Dr. Conecta oferece, cadastre seu consultório. É rápido e fácil!</p>
          </div>`
          this.actionModal.show = true
        }
      }
    },
    'actionModal.show': function (next) {
      if (!next && this.loaded) {
        this.actionModal.body = `
        <div class="col-6"><h2 style="color: white">Cadastre seu consultório!</h2>
        <p>Para usufruir de todas as funcionalidades que o Dr. Conecta oferece, cadastre seu consultório. É rápido e fácil!</p>
        </div>`
      }
    },
    getNewTab (next) {
      if (!next) {
        this.$store.dispatch('setModalAlert', {
          title: 'Agenda',
          body: 'Sua agenda no Google foi sincronizada com sucesso!',
          size: 'md',
          active: true
        })
      } else if (next === -1) {
        this.$store.dispatch('setModalAlert', {
          title: 'Agenda',
          body: 'Houve um erro na sincronização. Tente novamente mais tarde ou contate a administração.',
          size: 'md',
          active: true
        })
      }
    },
    '$store.getters.getActionModal': function (next) {
      this.actionModal.show = next
    }
  },

  created () {
    EventBus.$on(
      'updated-user-data',
      doctor => (this.doctor = doctor)
    )

    EventBus.$on(
      'open-agenda-online-controls',
      () => (this.agendaOnlineIsActive = true)
    )

    EventBus.$on(
      'close-agenda-online-controls',
      () => (this.agendaOnlineIsActive = false)
    )

    EventBus.$on(
      'show-save-office-alert',
      () => (this.actionModal.show = true)
    )

    this.getAppIntegration()
  },

  mounted () {
    // if (this.$store.getters.getNewTab) {
    //   this.$store.dispatch('setNewTab', null)
    //   window.open('javascript:void window.close()', 'drconecta_agenda', '')
    // }

    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })

    document.documentElement.style.setProperty('--size-lg', '960px')
    this.$store.dispatch('setActiveAppointments', null)
    this.fn_SHOW_PROGRESS()
    const arr = []
    const arr2 = []
    for (let route of this.fn_GET_CHILD_ROUTES(
      this.fn_IS_DOCTOR() ? 'Doctor' : 'Secretary'
    )) {
      if (route.meta.profile) {
        if (this.fn_IS_DOCTOR() || this.checkRoles(route)) {
          arr.push(route)
        }
      }
      if (route.meta.sidebar) {
        arr2.push(route)
      }
    }
    this.profileRoutes = arr
    this.sidebarRoutes = arr2
    if (this.fn_IS_SECRETARY()) {
      this.tourDisabled = true
      this.$http.get(`/user`, this.$store.getters.getAuthHeader).then(res => {
        let user = res.data
        this.$http
          .get('secretary/doctor', this.$store.getters.getAuthHeader)
          .then(res => {
            let doctors = []
            for (let doctor of res.data) {
              const avatar = doctor.profile_picture
                ? `${process.env.ROOT_API}/s3/file/doctor/${this.doctor.id}/profile_picture`
                : doctor.user.gender === 'F'
                  ? require('@/assets/img/f_default.png')
                  : require('@/assets/img/m_default.png')

              let obj = {
                id: doctor.user.id,
                name: doctor.user.name,
                displayName: doctor.display_name,
                profile_picture: avatar,
                gender: doctor.user.gender,
                roles: doctor.user.roles
              }
              doctors.push(obj)
              this.doctorList.push(doctor)
            }
            const userAvatar = user.profile_picture
              ? `${process.env.ROOT_API}/s3/file/user/${user.id}/profile_picture`
              : user.gender === 'F'
                ? require('@/assets/img/f_default.png')
                : require('@/assets/img/m_default.png')

            let profile = {
              id: user.id,
              name: user.name,
              email: user.email,
              displayName: user.display_name,
              picture: userAvatar,
              doctorList: doctors
            }

            this.$store.dispatch('setUserProfile', profile)
            this.fetchDoctor()
          })
          .catch(err => {
            console.log(err)
          })
      })
      return
    }
    this.$http
      .get(`/doctor/registration_status`, this.$store.getters.getAuthHeader)
      .then((res) => {
        // if (res.data.length === 0) {
        //   this.tourDisabled = true
        // } else if (res.data !== 'Finalizado') {
        //   this.$router.replace({ name: 'Register' })
        //   return
        // }
        this.fetchDoctor()
      }
      ).catch((err) => {
        console.log(err)
        this.$router.replace({ name: 'Logout' })
      }
      )

    if (this.$store.getters.getUser) {
      EventBus.$emit('show-office-select-session')
    }
  },
  methods: {
    initRoles () {
      this.$http
        .get(
          `secretary/secretary_doctor_office?filterAnd[d]=${this.doctorId}`,
          this.$store.getters.getAuthHeader
        )
        .then(res => {
          let roles = []
          for (let office of res.data.data) {
            roles = roles.concat(office.roles)
          }
          this.$store.dispatch('setAccessRoles', roles)
          this.accessRoles = roles
          this.fn_HIDE_PROGRESS()
          this.getAccessLogs()
          this.loaded = true
        })
    },
    checkRoles (r) {
      for (let accessRole of r.meta.accessRoles) {
        for (let role of this.$store.getters.getAccessRoles) {
          if (`ROLE_${accessRole}` === role) {
            return true
          }
        }
      }
    },

    fetchDoctor () {
      this.fn_GET_DOCTOR()
        .then((doctor) => {
          this.doctor = doctor
          const avatar = doctor.profile_picture
            ? `${process.env.ROOT_API}/s3/file/doctor/${this.doctor.id}/profile_picture`
            : doctor.user.gender === 'F'
              ? require('@/assets/img/f_default.png')
              : require('@/assets/img/m_default.png')

          if (this.fn_IS_DOCTOR()) {
            let profile = {
              id: this.doctor.user.id,
              name: this.doctor.user.name,
              email: this.doctor.user.email,
              displayName: this.doctor.display_name,
              picture: avatar
            }
            if (this.doctor.doctor_offices.length === 0) {
              this.actionModal.body = `
                <div class="col-6"><h2 style="color: white">Seja bem-vindo(a), ${this.doctor.display_name}</h2>
                <p>Agora só falta  cadastrar seu consultório para começar a utilizar o sistema Dr.Conecta</p>
                </div>`
              this.actionModal.show = true
              this.tourDisabled = true
            } else {
              // DESABILITANDO TOUR APÓS MUDANÇAS NAS SEÇÕES
              // this.$http.get(`/doctor/tour/${this.tourSlug}`, this.$store.getters.getAuthHeader).then((res) => {
              //   this.tourData = res.data
              //   console.log(res.data)
              //   this.tourDisabled = res.data.disabled
              //   if (!this.tourDisabled && this.$route.name !== 'DoctorAgenda') {
              //     this.$router.push('/doctor')
              //   }
              // }).catch((err) => [
              //   console.log(err)
              // ])
            }
            this.$store.dispatch('setUserProfile', profile)
            this.fn_HIDE_PROGRESS()
            this.getAccessLogs()
            this.loaded = true
          } else {
            this.initRoles()
          }
        })
        .catch(err => console.log(err))
    },
    getAccessLogs () {
      this.$http
        .get(
          `/access_log?order[al.createdAt]=desc`,
          this.$store.getters.getAuthHeader
        )
        .then(res => {
          let data = res.data.data
          for (let row of data) {
            for (let field in row) {
              if (!row[field]) {
                row[field] = '--'
              }
            }
          }
          this.lastAccess = data[1].created_at || null
          this.accessLog = data
        })
        .catch(err => {
          console.log(err)
        })
    },
    getWindowWidth () {
      this.windowWidth = document.documentElement.clientWidth
    },
    getAppIntegration () {
      this.$http
        .get('/doctor/app_integration', this.$store.getters.getAuthHeader)
        .then(res => this.$store.dispatch('setAppIntegration', res.data['app_integration']))
    }
  }
}
</script>
